const PLBTypes = {
  PLB_HEDGING: "plb-hedging",
  PLB_LOCQPAY: "plb-locqpay",
};

export default PLBTypes;
